module.exports = __webpack_public_path__ + "img/jiangsu.ec12b9b9.png";